var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
/* Reusable enums. */
var COOK_REGION;
(function (COOK_REGION) {
    COOK_REGION["PITT"] = "PITT";
    COOK_REGION["NASH"] = "NASH";
    COOK_REGION["HGCA"] = "HGCA";
})(COOK_REGION || (COOK_REGION = {}));
var ADDRESS_TYPE;
(function (ADDRESS_TYPE) {
    ADDRESS_TYPE["ADDRESS_TYPE_UNKNOWN"] = "ADDRESS_TYPE_UNKNOWN";
    ADDRESS_TYPE["ADDRESS_TYPE_RESIDENTIAL"] = "ADDRESS_TYPE_RESIDENTIAL";
    ADDRESS_TYPE["ADDRESS_TYPE_NON_RESIDENTIAL"] = "ADDRESS_TYPE_NON_RESIDENTIAL";
})(ADDRESS_TYPE || (ADDRESS_TYPE = {}));
var PET_TYPE;
(function (PET_TYPE) {
    PET_TYPE["DOG"] = "DOG";
    PET_TYPE["CAT"] = "CAT";
})(PET_TYPE || (PET_TYPE = {}));
var RECIPE_MODE;
(function (RECIPE_MODE) {
    RECIPE_MODE["FIXED"] = "FIXED";
    RECIPE_MODE["ROTATE"] = "ROTATE";
    RECIPE_MODE["MIX"] = "MIX";
})(RECIPE_MODE || (RECIPE_MODE = {}));
var ORDER_SOURCE;
(function (ORDER_SOURCE) {
    ORDER_SOURCE["ORDER_SOURCE_UNKNOWN"] = "ORDER_SOURCE_UNKNOWN";
    ORDER_SOURCE["ORDER_SOURCE_SUBSCRIPTION"] = "ORDER_SOURCE_SUBSCRIPTION";
    ORDER_SOURCE["ORDER_SOURCE_ONE_TIME_CUSTOMER"] = "ORDER_SOURCE_ONE_TIME_CUSTOMER";
    ORDER_SOURCE["ORDER_SOURCE_ONE_TIME_REPLACEMENT"] = "ORDER_SOURCE_ONE_TIME_REPLACEMENT";
    ORDER_SOURCE["ORDER_SOURCE_ONE_TIME_MARKETING"] = "ORDER_SOURCE_ONE_TIME_MARKETING";
    ORDER_SOURCE["ORDER_SOURCE_ONE_TIME_SNIP"] = "ORDER_SOURCE_ONE_TIME_SNIP";
    ORDER_SOURCE["ORDER_SOURCE_REFERRAL"] = "ORDER_SOURCE_REFERRAL";
})(ORDER_SOURCE || (ORDER_SOURCE = {}));
var ORDER_STATUS;
(function (ORDER_STATUS) {
    ORDER_STATUS["CREATED"] = "created";
    ORDER_STATUS["COOKED"] = "cooked";
    ORDER_STATUS["PRINTED"] = "printed";
    ORDER_STATUS["PACKAGED"] = "packaged";
    ORDER_STATUS["SHIPPED"] = "shipped";
    ORDER_STATUS["DELIVERED"] = "delivered";
    ORDER_STATUS["DELIVERY_FAILED"] = "delivery failed";
    ORDER_STATUS["INTERNAL_MISSORT"] = "internal missort";
    ORDER_STATUS["SENT_TO_DCX"] = "sent to dcx";
})(ORDER_STATUS || (ORDER_STATUS = {}));
var ORDER_CHARGE_STATUS;
(function (ORDER_CHARGE_STATUS) {
    ORDER_CHARGE_STATUS["SUCCEEDED"] = "succeeded";
    ORDER_CHARGE_STATUS["FAILED"] = "failed";
    ORDER_CHARGE_STATUS["REFUNDED"] = "refunded";
})(ORDER_CHARGE_STATUS || (ORDER_CHARGE_STATUS = {}));
var DROPSHIP_ORDER_STATUS;
(function (DROPSHIP_ORDER_STATUS) {
    DROPSHIP_ORDER_STATUS["IMPORTED"] = "imported";
    DROPSHIP_ORDER_STATUS["SHIP_DATE_CONFIRMED"] = "ship date confirmed";
    DROPSHIP_ORDER_STATUS["LABELS_PRINTED"] = "printed";
    DROPSHIP_ORDER_STATUS["FULFILLED"] = "fulfilled";
    DROPSHIP_ORDER_STATUS["ASN_SENT"] = "asn sent";
    DROPSHIP_ORDER_STATUS["CANCELLED"] = "cancelled";
    DROPSHIP_ORDER_STATUS["COMPLETED"] = "completed";
})(DROPSHIP_ORDER_STATUS || (DROPSHIP_ORDER_STATUS = {}));
var TERMINAL_DROPSHIP_ORDER_STATUSES = [
    DROPSHIP_ORDER_STATUS.CANCELLED,
    DROPSHIP_ORDER_STATUS.COMPLETED,
];
var PAYMENT_METHOD_BRAND;
(function (PAYMENT_METHOD_BRAND) {
    PAYMENT_METHOD_BRAND["AMERICAN_EXPRESS"] = "American Express";
    PAYMENT_METHOD_BRAND["DISCOVER"] = "Discover";
    PAYMENT_METHOD_BRAND["MASTERCARD"] = "MasterCard";
    PAYMENT_METHOD_BRAND["VISA"] = "Visa";
})(PAYMENT_METHOD_BRAND || (PAYMENT_METHOD_BRAND = {}));
var PAYMENT_METHOD_ICONS = (_a = {},
    _a[PAYMENT_METHOD_BRAND.AMERICAN_EXPRESS] = 'icons/new/payment/amex.png',
    _a[PAYMENT_METHOD_BRAND.DISCOVER] = 'icons/new/payment/discover.png',
    _a[PAYMENT_METHOD_BRAND.MASTERCARD] = 'icons/new/payment/mastercard.png',
    _a[PAYMENT_METHOD_BRAND.VISA] = 'icons/new/payment/visa.png',
    _a);
var ACTIVITIES = [
    { value: 1.1, displayName: 'Normal' },
    { value: 1.3, displayName: 'High' },
    { value: 1.5, displayName: 'Very high' },
];
var ACTIVITIES_MAP = (_b = {},
    _b[ACTIVITIES[0].value] = ACTIVITIES[0].displayName,
    _b[ACTIVITIES[1].value] = ACTIVITIES[1].displayName,
    _b[ACTIVITIES[2].value] = ACTIVITIES[2].displayName,
    _b);
var ACTIVITY_LEVELS = [
    {
        value: 1.1,
        displayName: 'Average',
        description: '1 hour of daily physical activity',
    },
    {
        value: 1.3,
        displayName: 'Active',
        description: '2+ hours of daily physical activity',
    },
    {
        value: 1.5,
        displayName: 'Athlete',
        description: '3+ hours of intense daily physical activity',
    },
];
var DELIVERY_INTERVALS = {
    WEEKLY: 'weekly',
    BIWEEKLY: 'biweekly',
    THREE_WEEKS: '3 weeks',
    MONTHLY: 'monthly',
    SIX_WEEKS: '6 weeks',
    EIGHT_WEEKS: '8 weeks',
};
var DELIVERY_INTERVALS_DISPLAY_MAP = (_c = {},
    _c[DELIVERY_INTERVALS.WEEKLY] = 'week',
    _c[DELIVERY_INTERVALS.BIWEEKLY] = '2 weeks',
    _c[DELIVERY_INTERVALS.THREE_WEEKS] = '3 weeks',
    _c[DELIVERY_INTERVALS.MONTHLY] = '4 weeks',
    _c[DELIVERY_INTERVALS.SIX_WEEKS] = '6 weeks',
    _c[DELIVERY_INTERVALS.EIGHT_WEEKS] = '8 weeks',
    _c);
var WEEK_OF_MEALS_MAP = (_d = {},
    _d[DELIVERY_INTERVALS.WEEKLY] = '1 week of meals',
    _d[DELIVERY_INTERVALS.BIWEEKLY] = '2 weeks of meals',
    _d[DELIVERY_INTERVALS.THREE_WEEKS] = '3 weeks of meals',
    _d[DELIVERY_INTERVALS.MONTHLY] = '4 weeks of meals',
    _d[DELIVERY_INTERVALS.SIX_WEEKS] = '6 weeks of meals',
    _d[DELIVERY_INTERVALS.EIGHT_WEEKS] = '8 weeks of meals',
    _d);
var DELIVERY_INTERVALS_SUPPLY_MAP = (_e = {},
    _e[DELIVERY_INTERVALS.WEEKLY] = '1 week supply',
    _e[DELIVERY_INTERVALS.BIWEEKLY] = '2 weeks supply',
    _e[DELIVERY_INTERVALS.THREE_WEEKS] = '3 weeks supply',
    _e[DELIVERY_INTERVALS.MONTHLY] = '4 weeks supply',
    _e[DELIVERY_INTERVALS.SIX_WEEKS] = '6 weeks supply',
    _e[DELIVERY_INTERVALS.EIGHT_WEEKS] = '8 weeks supply',
    _e);
var DELIVERY_INTERVALS_NUMBER_MAP = (_f = {},
    _f[DELIVERY_INTERVALS.WEEKLY] = 1,
    _f[DELIVERY_INTERVALS.BIWEEKLY] = 2,
    _f[DELIVERY_INTERVALS.THREE_WEEKS] = 3,
    _f[DELIVERY_INTERVALS.MONTHLY] = 4,
    _f[DELIVERY_INTERVALS.SIX_WEEKS] = 6,
    _f[DELIVERY_INTERVALS.EIGHT_WEEKS] = 8,
    _f);
var DAYS_OF_FOOD_PER_INTERVAL_MAP = (_g = {},
    _g[DELIVERY_INTERVALS.WEEKLY] = 7,
    _g[DELIVERY_INTERVALS.BIWEEKLY] = 14,
    _g[DELIVERY_INTERVALS.THREE_WEEKS] = 21,
    _g[DELIVERY_INTERVALS.MONTHLY] = 28,
    _g[DELIVERY_INTERVALS.SIX_WEEKS] = 42,
    _g[DELIVERY_INTERVALS.EIGHT_WEEKS] = 56,
    _g);
var DEPRECATED_PET_TYPES = [PET_TYPE.CAT];
var PET_GENDERS = { FEMALE: 'female', MALE: 'male' };
var MIN_MAX_WEIGHTS = (_h = {},
    _h[PET_TYPE.DOG] = { min: 3, max: 280 },
    _h[PET_TYPE.CAT] = { min: 2, max: 30 },
    _h);
var SKIP_TRANSITION_FOODS = [
    'home_cooked',
    'commercial_fresh',
    'commercial_frozen',
];
var PET_SURVEYS = (_j = {},
    _j[PET_TYPE.DOG] = ['wellness', 'microbiome', 'medical', 'oral', 'behavior'],
    _j[PET_TYPE.CAT] = ['wellness', 'microbiome', 'medical', 'oral'],
    _j);
// Keep values consistent with PetFeature definition in enums.proto.
var PET_FEATURES = {
    FOOD_PERSONALIZED: 'FOOD_PERSONALIZED',
    FOOD_FIXED_SKU: 'FOOD_FIXED_SKU',
};
var SUBSCRIPTION_TYPES = {
    FLEXIBLE: 'flex',
    OTTO: 'otto',
    PERSONALIZED: 'personalized',
};
// Values user may check off during sign up flow to affect recommendations. Stored in PetSurvey.
var PURCHASING_MOTIVATIONS = {
    picky_eater: 'Picky eater',
    allergies: 'Food allergies or a sensitive stomach',
    coat_issues: 'Dull or flaky coat',
    no_issues: 'No issues',
};
// Define all valid days of the week for cook dates.
var COOK_CYCLE_DAYS = [1, 2, 3, 4];
// Keep in sync with customer_utils.py
var CUSTOMER_STATE = {
    DELETED: 'DELETED',
    IS_FOOD_SUBSCRIBER: 'IS_FOOD_SUBSCRIBER',
    NOT_FOOD_SUBSCRIBER: 'NOT_FOOD_SUBSCRIBER',
};
var TRIAL_TYPES = {
    TRIAL_TYPE_UNKNOWN: 'TRIAL_TYPE_UNKNOWN',
    TRIAL_TYPE_NONE: 'TRIAL_TYPE_NONE',
    TRIAL_TYPE_SUBSCRIPTION: 'TRIAL_TYPE_SUBSCRIPTION',
    TRIAL_TYPE_ONE_TIME: 'TRIAL_TYPE_ONE_TIME',
};
var EXPRESS_SHIPPING = ['STANDARD_OVERNIGHT', 'PRIORITY_OVERNIGHT', 'FEDEX_2_DAY'];
// Keep in sync with sites/shared_api/unsubscribe/churn_reasons.py
var CHURN_REASONS = [
    { value: 'no_subscription', text: 'No subscription' },
    { value: 'did_not_see_cost', text: 'Did not see cost' },
    { value: 'cost', text: 'Cost' },
    { value: 'transition_issue', text: 'Transition issue' },
    { value: 'vet', text: 'Vet reason' },
    { value: 'allergies', text: 'Allergies' },
    { value: 'not_eating', text: 'Pet not eating' },
    { value: 'digestion_issue', text: 'Digestion issue' },
    { value: 'poor_delivery', text: 'Poor delivery' },
    { value: 'damaged_delivery', text: 'Damaged delivery' },
    { value: 'frequency_issue', text: 'Frequency issue' },
    { value: 'warm_meal', text: 'Warm meal' },
    { value: 'missing_product', text: 'Missing product' },
    { value: 'packaging', text: 'Packaging issue/Unsatisfied with packaging' },
    { value: 'damaged_product', text: 'Damaged product' },
    { value: 'food_quality', text: 'Food quality' },
    { value: 'storage', text: 'Lack storage' },
    { value: 'trying_out', text: 'Trying out' },
    { value: 'not_enough_variety', text: 'Not enough variety' },
    { value: 'gone', text: 'Pet gone' },
    { value: 'died', text: 'Died' },
    { value: 'moved', text: 'Moved outside delivery zone' },
    { value: 'charge_failed', text: 'Charge failed' },
    { value: 'extended_pause', text: 'Extended pause' },
    { value: 'duplicate', text: 'Duplicate' },
    { value: 'marketing', text: 'Marketing' },
    { value: 'negative_customer', text: 'Negative customer' },
    { value: 'customer_did_not_supply_reason', text: 'Customer did not supply reason' },
    // Below are legacy values no longer in use but old/deleted customers may still have them
    // and it's not really possible to map 1:1 the new:old values
    { value: 'sick', text: 'Pet became sick', disabled: true },
    { value: 'medical', text: 'Medical/vet reason', disabled: true },
    { value: 'delivery_frustration', text: 'Delivery frustration', disabled: true },
    { value: 'service_confusion', text: 'Service confusion', disabled: true },
    { value: 'unsatisfied_recipe', text: 'Unsatisfied with recipe', disabled: true },
    {
        value: 'unsatisfied_customer_service',
        text: 'Unsatisfied with customer service',
        disabled: true,
    },
    { value: 'quality_control', text: 'Quality control', disabled: true },
    { value: 'lifestyle', text: 'Lifestyle incompatibility', disabled: true },
    { value: 'not_serving', text: 'Not serving', disabled: true },
    { value: 'unknown', text: 'Unknown', disabled: true },
];
// Churn reasons that do not get shown promos to resubscribe to food.
var NO_RESUBSCRIBE_CHURN_REASONS = ['duplicate', 'marketing', 'not_serving'];
var HEALTH_REPORTS = [
    { name: 'Weight Report', link: 'weight' },
    { name: 'Gastrointestinal Health Report', link: 'gi' },
    { name: 'Joint Issue Report', link: 'joint' },
];
var CHURN_OFFER_STATUSES = {
    acceptedOffer: 'accepted_offer',
    alreadyCancelled: 'already_cancelled',
    alreadyRedeemed: 'already_redeemed',
    alreadyUnsubscribed: 'already_unsubscribed',
    control: 'control',
    declinedOffer: 'declined_offer',
    deletePets: 'delete_pets',
};
var CHURN_OFFERS = {
    fiftyPercentOffNextOrder: 'fifty_percent_off_next_order',
    flexibleMealPlan: 'flexible_meal_plan',
};
var TREATS_PRODUCT_TYPES = {
    beefBlueberryTreats7oz: 'beef-blueberry-treats-7oz',
    beefJerkyTreats4oz: 'beef-jerky-treats-4oz',
    beefJerkyTreats4ozFree: 'beef-jerky-treats-4oz-free',
    chickenCranberryTreats7oz: 'chicken-cranberry-treats-7oz',
    chickenJerkyTreats4oz: 'chicken-jerky-treats-4oz',
    chickenJerkyTreats4ozFree: 'chicken-jerky-treats-4oz-free',
    sweetPotatoTreats6oz: 'sweet-potato-treats-6oz',
};
// Override the product display name for freebies.
var FREE_PRODUCT_DISPLAY_NAMES = (_k = {},
    _k[TREATS_PRODUCT_TYPES.beefJerkyTreats4ozFree] = 'Beef Jerky Treats',
    _k[TREATS_PRODUCT_TYPES.chickenJerkyTreats4ozFree] = 'Chicken Jerky Treats',
    _k);
var VARIETY_PACK_PRODUCT_TYPES = {
    varietyPackDogs: 'variety-pack-dogs',
    varietyPackDogs200g: 'variety-pack-dogs-200g',
};
var ADD_ON_MEAL_BUNDLE_PRODUCT_TYPES = {
    mealsBundle400gBeef: 'meals-bundle-400g-beef',
    mealsBundle400gChicken: 'meals-bundle-400g-chicken',
    mealsBundle400gPork: 'meals-bundle-400g-pork',
    mealsBundle400gTurkey: 'meals-bundle-400g-turkey',
};
var ADD_ON_PROBIOTICS_PRODUCT_TYPES = {
    dogFullSpectrum: 'probiotic-dog-full-spectrum',
    dogGITargeted: 'probiotic-dog-gi',
};
// Keep in sync with lib.product_type_utils insert product IDs.
var OPS_INSERTS_AND_PROMOTIONAL_PRODUCT_TYPES = [
    'aafco-insert',
    'birthday-item',
    'first-subscription-order-insert',
    'sampler-pack-paper-insert',
    'seasonal-insert-one',
    'seasonal-insert-two',
    'second-subscription-order-insert',
    'storage-container',
    'third-subscription-order-insert',
];
// Perishable products are grouped by lot and tracked by lot codes.
var LOT_TRACKED_PRODUCT_TYPES = __assign(__assign(__assign({}, ADD_ON_MEAL_BUNDLE_PRODUCT_TYPES), VARIETY_PACK_PRODUCT_TYPES), { subscriptionMeals: 'subscription-meals' });
var PRODUCT_TYPES = __assign(__assign({}, LOT_TRACKED_PRODUCT_TYPES), ADD_ON_PROBIOTICS_PRODUCT_TYPES);
var DOG_RECIPES = ['beef', 'chicken', 'lamb', 'pork', 'turkey', 'turkey_chicken'];
var DOG_RECIPE_TO_GRAMS_OUT_OF_STOCK = {};
var RECIPES_TO_PRICE_INDICATORS = {
    beef: '$$$$',
    turkey: '$$$',
    chicken: '$$',
    pork: '$$$',
    lamb: '$$$$',
    turkey_chicken: '$$$',
};
var RECIPES_TO_DISPLAY_NAMES = {
    beef: 'Beef Mash',
    turkey: 'Turkey Fare',
    chicken: 'Chicken Cuisine',
    pork: 'Pork Potluck',
    lamb: 'Lamb Pilaf',
    turkey_chicken: 'Turkey & Chicken Cookout',
};
// Order status that do not allow admins to make changes to the order.
var INELIGIBLE_ORDER_STATUS_TO_UPDATE = [
    ORDER_STATUS.PRINTED,
    ORDER_STATUS.PACKAGED,
    ORDER_STATUS.SHIPPED,
    ORDER_STATUS.DELIVERED,
];
// keep in sync with OrderFulfillmentItemExceptionReason in enums.proto
var ORDER_FULFILLMENT_ITEM_EXCEPTION_REASONS = {
    EXCEPTION_REASON_UNKNOWN: 0,
    EXCEPTION_REASON_NOT_SCANNED: 1,
    EXCEPTION_REASON_NOT_IN_ORDER: 2,
    EXCEPTION_REASON_QUANTITY_EXCEEDED: 3,
};
// Must be kept in sync with REFUND_DESTINATIONS in enums.proto.
var REFUND_DESTINATIONS = {
    REFUND_DESTINATION_BALANCE: 'REFUND_DESTINATION_BALANCE',
    REFUND_DESTINATION_CARD: 'REFUND_DESTINATION_CARD',
};
// Recipes are available to v9 customers, but only come in v10 bag sizes.
var V10_ONLY_RECIPES = ['lamb', 'turkey_chicken'];
// Breed list by pet type
var BREED_LIST = (_l = {},
    _l[PET_TYPE.DOG] = [
        'Affenpinscher',
        'Afghan Hound',
        'Aidi (Atlas Mountain Dog)',
        'Airedale Terrier',
        'Akbash Dog',
        'Akita',
        'Alaskan Klee Kai',
        'Alaskan Malamute',
        'Alentejo Mastiff',
        'Alpine Drachsbracke',
        'American Black & Tan Coonhound',
        'American Bulldog',
        'American English Coonhound',
        'American Eskimo Dog (Miniature)',
        'American Eskimo Dog (Standard)',
        'American Eskimo Dog (Toy)',
        'American Foxhound',
        'American Hairless Terrier',
        'American Leopard Hound',
        'American Pit Bull Terrier',
        'American Water Spaniel',
        'Anatolian Shepherd',
        'Anglo-Francais de Petite Venerie',
        'Appenzeller',
        'Ariegeois',
        'Aussiedoodle',
        'Australian Cattle Dog',
        'Australian Kelpie',
        'Australian Shepherd',
        'Australian Terrier',
        'Austrian Black and Tan Hound',
        'Austrian Pinscher',
        'Azawakh',
        'Barak',
        'Barbet',
        'Basenji',
        'Basset Artesien Normand',
        'Basset Bleu De Gascogne',
        'Basset Fauve De Bretagne',
        'Basset Hound',
        'Bavarian Mountain Hound',
        'Beagle',
        'Beagle Harrier',
        'Bearded Collie',
        'Beauceron',
        'Bedlington Terrier',
        'Belgian Malinois',
        'Belgian Sheepdog',
        'Belgian Shepherd Dog',
        'Belgian Tervuren',
        'Bergamasco',
        'Berger Des Pyrenees',
        'Berger Picard',
        'Bernedoodle',
        'Bernese Mountain Dog',
        'Bichon Frise',
        'Billy',
        'Black and Tan Coonhound',
        'Black Forest Hound (Slovakian Hound)',
        'Black Mouth Cur',
        'Black Russian Terrier',
        'Bloodhound',
        'Bluetick Coonhound',
        'Boerboel',
        'Bolognese',
        'Border Collie',
        'Border Terrier',
        'Borzoi',
        'Boston Terrier',
        'Bouvier Des Ardennes',
        'Bouvier des Flandres',
        'Boxer',
        'Boykin Spaniel',
        'Bracco Italiano',
        "Braque D'Auvergne",
        'Braque de Bourbonais',
        "Braque de l'Ariege",
        'Braque Francais, de Grande Taille',
        'Braque Francais, de Petite Taille',
        'Braque Saint Germain',
        'Briard',
        'Briquet Griffon Vendeen',
        'Brittany',
        'Brussels Griffon',
        'Bull Terrier',
        'Bullmastiff',
        'Ca de Bestiar (Majorca Shepherd Dog)',
        'Cairn Terrier',
        'Canaan Dog',
        'Canadian Eskimo Dog',
        'Cane Corso Italiano',
        'Cao de Castro Laboreiro',
        'Cardigan Welsh Corgi',
        'Carolina Dog',
        'Catalonian Sheepdog',
        'Caucasian Ovcharka',
        'Cavachon',
        'Cavalier King Charles Spaniel',
        'Cavapoo',
        'Central Asian Shepherd',
        'Cesky Fousek',
        'Cesky Terrier',
        'Chart Polski (Polish Greyhound)',
        'Chesapeake Bay Retriever',
        "Chien d'Artois",
        'Chien Francais Blanc et Noir',
        'Chien Francais Tricolore',
        'Chihuahua',
        'Chinese Crested',
        'Chinese Shar-Pei',
        'Chinook',
        'Chiweenie',
        'Chow Chow',
        'Cimarron Uruguayo',
        'Ciobanesc Romanesc Carpatin',
        'Ciobanesc Romanesc Mioritic',
        "Cirneco dell'Etna",
        'Clumber Spaniel',
        'Cockapoo',
        'Cocker Spaniel',
        'Collie',
        'Coton De Tulear',
        'Croatian Sheepdog',
        'Curly-Coated Retriever',
        'Czechoslovakian Vlcak (Czechoslovakian Wolfdog)',
        'Dachshund (Miniature)',
        'Dachshund (Standard)',
        'Dalmatian',
        'Dandie Dinmont Terrier',
        'Danish Broholmer',
        'Danish-Swedish Farmdog',
        'Deutsche Bracke',
        'Deutscher Wachtelhund (German Spaniel)',
        'Doberman Pinscher',
        'Dogo Argentino',
        'Dogue De Bordeaux',
        'Drentse Patrijshond',
        'Drever',
        'Dunker',
        'Dutch Shepherd',
        'Dutch Smoushond',
        'East Siberian Laika',
        'English Bulldog',
        'English Cocker Spaniel',
        'English Coonhound',
        'English Foxhound',
        'English Pointer',
        'English Setter',
        'English Shepherd',
        'English Springer Spaniel',
        'English Toy Spaniel',
        'Entlebucher',
        'Epagneul Bleu de Picardie',
        'Epagneul Breton',
        'Epagneul de Pont-Audemer',
        'Epagneul Francais (French Spaniel)',
        'Epagneul Picard',
        'Estrela Mountain Dog',
        'Eurasian',
        'Field Spaniel',
        'Finnish Hound',
        'Finnish Lapphund',
        'Finnish Spitz',
        'Flat-Coated Retriever',
        'Francais Blanc et Orange',
        'French Bulldog',
        'Fresian Water Dog',
        'German Long Haired Pointer',
        'German Pinscher',
        'German Rough Haired Pointer',
        'German Shepherd Dog',
        'German Shorthaired Pointer',
        'German Spitz',
        'German Wirehaired Pointer',
        'Giant Schnauzer',
        'Glen of Imaal Terrier',
        'Golden Retriever',
        'Goldendoodle',
        'Gordon Setter',
        'Grand Basset Griffon Vendeen',
        'Grand Bleu De Gascogne',
        'Grand Gascon-Saintongeois',
        'Grand Griffon Vendeen',
        'Great Anglo-Francais Tricolor Hound',
        'Great Anglo-Francais White and Black Hound',
        'Great Anglo-Francais White and Orange Hound',
        'Great Dane',
        'Great Pyrenees',
        'Greater Swiss Mountain Dog',
        'Greenland Dog',
        'Greyhound',
        'Griffon Bleu de Gascogne',
        'Griffon Fauve de Bretagne',
        'Griffon Nivernais',
        'Haldenstover (Halden Hound)',
        'Hamiltonstovare',
        'Hanoverian Hound',
        'Harrier',
        'Havanese',
        'Hellenic Hound',
        'Hokkaido',
        'Hovawart',
        'Hungarian Greyhound (Magyar Agar)',
        'Hungarian Wire-Haired Vizsla',
        'Hygen Hound',
        'Ibizan Hound',
        'Icelandic Sheepdog',
        'Irish Red and White Setter',
        'Irish Setter',
        'Irish Terrier',
        'Irish Water Spaniel',
        'Irish Wolfhound',
        'Istrian Coarse-Haired Hound',
        'Istrian Short-Haired Hound',
        'Italian Greyhound',
        'Italian Hound',
        'Jack Russell Terrier',
        'Jagdterrier',
        'Japanese Akita',
        'Japanese Chin',
        'Japanese Spitz',
        'Japanese Terrier',
        'Jindo',
        'Kai',
        'Kangal Dog',
        'Karelian Bear Dog',
        'Karst Shepherd Dog',
        'Keeshond',
        'Kerry Blue Terrier',
        'Kishu',
        'Komondor',
        'Kooikerhondje',
        'Kromfohrlander',
        'Kuvasz',
        'Labradoodle',
        'Labrador Retriever',
        'Lagotto Romagnolo',
        'Lakeland Terrier',
        'Lancashire Heeler',
        'Lapinporokoira (Lapponian Herder)',
        'Large Munsterlander',
        'Leonberger',
        'Lhasa Apso',
        'Louisiana Catahoula Leopard Dog',
        'Lowchen',
        'Lundehund',
        'Majorca Mastiff',
        'Maltese',
        'Maltipoo',
        'Manchester Terrier (Standard)',
        'Manchester Terrier (Toy)',
        'Maremma Sheepdog',
        'Mastiff',
        'Miniature goldendoodle',
        'Miniature American Shepherd',
        'Miniature Bull Terrier',
        'Miniature Pinscher',
        'Miniature Schnauzer',
        'Montenegrin Mountain Hound',
        'Morkie',
        'Mountain Cur',
        'Mudi',
        'Multi-Colored Poodle',
        'Multi-Colored Standard Poodle',
        'Neapolitan Mastiff',
        'Newfoundland',
        'Norfolk Terrier',
        'Norrbottenspetz',
        'Norwegian Buhund',
        'Norwegian Elkhound',
        'Norwegian Lundehund',
        'Norwich Terrier',
        'Nova Scotia Duck Tolling Retriever',
        'Old Danish Pointing Dog',
        'Old English Sheepdog',
        'Otterhound',
        'Owczarek Podhalanski',
        'Papillon',
        'Parson Russell Terrier',
        'Patterdale Terrier',
        'Pekingese',
        'Pembroke Welsh Corgi',
        'Perdiguero de Burgos',
        'Perro De Presa Canario',
        'Peruvian Inca Orchid',
        'Petit Basset Griffon Vendeen',
        'Petit Bleu De Gascogne',
        'Petit Gascon-Saintongeois',
        'Pharaoh Hound',
        'Plott Hound',
        'Podenco Canario',
        'Podengo Portugueso',
        'Poitevin',
        'Polish Hound',
        'Polish Lowland Sheepdog (Polski Owczarek Nizinny)',
        'Pomchi',
        'Pomeranian',
        'Pomsky',
        'Poodle (Miniature)',
        'Poodle (Standard)',
        'Poodle (Toy)',
        'Porcelaine',
        'Portuguese Podengo Pequeno',
        'Portuguese Pointer',
        'Portuguese Sheepdog',
        'Portuguese Water Dog',
        'Posavaz Hound',
        'Pudelpointer',
        'Puggle',
        'Pug',
        'Puli',
        'Pumi',
        'Pyrenean Mastiff',
        'Pyrenean Shepherd',
        'Rat Terrier',
        'Redbone Coonhound',
        'Rhodesian Ridgeback',
        'Rottweiler',
        'Russian-European Laika',
        'Russkiy Toy',
        'Saarloosewolfdog',
        'Saint Bernard',
        'Saluki',
        'Samoyed',
        'Sarplaninac',
        'Schapendoes',
        'Schiller Hound',
        'Schipperke',
        'Schnoodle',
        'Scottish Deerhound',
        'Scottish Terrier',
        'Sealyham Terrier',
        'Serbian Hound',
        'Serbian Tricolor Hound',
        'Shetland Sheepdog',
        'Shiba',
        'Shih Tzu',
        'Shihpoo',
        'Shikoku',
        'Shorkie',
        'Siberian Husky',
        'Silken Windhound',
        'Silky Terrier',
        'Skye Terrier',
        'Sloughi',
        'Slovac Cuvac',
        'Slovakian Wire-Haired Pointing Dog',
        'Smaland Hound',
        'Small Munsterlander',
        'Small Swiss Hound',
        'Smooth Fox Terrier',
        'Soft-Coated Wheaten Terrier',
        'South Russian Shepherd Dog',
        'Spanish Greyhound',
        'Spanish Hound',
        'Spanish Mastiff',
        'Spanish Water Dog',
        'Spinone Italiano',
        'Sporting Lucas Terrier',
        'Stabyhoun',
        'American Staffordshire Terrier',
        'Standard Schnauzer',
        "Stephens' Cur",
        'Stumpy Tail Cattle Dog',
        'Styrian Coarse Haired Hound',
        'Sussex Spaniel',
        'Swedish Elkhound',
        'Swedish Lapphund',
        'Swedish Vallhund',
        'Swiss Hound',
        'Teddy Roosevelt Terrier',
        'Thai Ridgeback',
        'Tibetan Mastiff',
        'Tibetan Spaniel',
        'Tibetan Terrier',
        'Tornjak',
        'Tosa Ken',
        'Toy Fox Terrier',
        'Transylvanian Hound',
        'Treeing Cur',
        'Treeing Feist',
        'Treeing Walker Coonhound',
        'Tyrolean Hound',
        'Vizsla',
        'Vizsla (Wirehaired)',
        'Volpino Italiano',
        'Weimaraner',
        'Welsh Hound',
        'Welsh Springer Spaniel',
        'Welsh Terrier',
        'West Highland White Terrier',
        'West Siberian Laika',
        'Westphalian Dachsbracke',
        'Whippet',
        'White Shepherd',
        'Wire Fox Terrier',
        'Wirehaired Pointing Griffon',
        'Xoloitzcuintli - Mexican Hairless Terrier (Miniature)',
        'Xoloitzcuintli - Mexican Hairless Terrier (Standard)',
        'Xoloitzcuintli - Mexican Hairless Terrier (Toy)',
        'Yorkiepoo',
        'Yorkshire Terrier',
        'Other',
        'Unknown',
    ],
    _l[PET_TYPE.CAT] = [
        'Abyssinian',
        'American Bobtail',
        'American Curl',
        'American Shorthair',
        'American Wirehair',
        'Arabian Mau',
        'Balinese',
        'Birman',
        'Bombay',
        'British Shorthair',
        'Burmese',
        'Burmilla',
        'Bengal',
        'Chartreux',
        'Colorpoint Shorthair',
        'Cornish Rex',
        'Devon Rex',
        'Domestic Long-haired',
        'Domestic Medium-haired',
        'Domestic Short-haired',
        'Egyptian Mau',
        'European Burmese',
        'Exotic',
        'Havana Brown',
        'Japanese Bobtail',
        'Khao Manee',
        'Korat',
        'LaPerm',
        'Lyoki',
        'Maine Coon',
        'Manx',
        'Norwegian Forest',
        'Ocicat',
        'Oriental',
        'Persian',
        'Ragamuffin',
        'Ragdoll',
        'Russian Blue',
        'Scottish Fold',
        'Selkirk Rex',
        'Siamese',
        'Siberian',
        'Singapura',
        'Somali',
        'Sphynx',
        'Tonkinese',
        'Toybob',
        'Turkish Angora',
        'Turkish Van',
        'Unknown',
        'Other',
    ],
    _l);
var SIGNUP_BREED_LIST = (_m = {},
    _m[PET_TYPE.DOG] = __spreadArray(__spreadArray([], BREED_LIST[PET_TYPE.DOG], true), ['Mixed Breed'], false),
    _m[PET_TYPE.CAT] = __spreadArray(__spreadArray([], BREED_LIST[PET_TYPE.CAT], true), ['Mix'], false),
    _m);
// Keep in sync with missing_shipments cloud run job.
var IN_TRANSIT_TRACKING_STATUSES = ['in_transit', 'out_for_delivery'];
var HTTP_METHODS = {
    POST: 'POST',
    GET: 'GET',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};
var PHOTO_BASE_URL = '/api/customer/pet/photo/';
export { ACTIVITIES, ACTIVITIES_MAP, ACTIVITY_LEVELS, ADDRESS_TYPE, ADD_ON_MEAL_BUNDLE_PRODUCT_TYPES, ADD_ON_PROBIOTICS_PRODUCT_TYPES, BREED_LIST, SIGNUP_BREED_LIST, CHURN_OFFER_STATUSES, CHURN_OFFERS, CHURN_REASONS, COOK_CYCLE_DAYS, COOK_REGION, CUSTOMER_STATE, DAYS_OF_FOOD_PER_INTERVAL_MAP, DELIVERY_INTERVALS, DELIVERY_INTERVALS_DISPLAY_MAP, DELIVERY_INTERVALS_NUMBER_MAP, DELIVERY_INTERVALS_SUPPLY_MAP, DEPRECATED_PET_TYPES, DOG_RECIPES, DOG_RECIPE_TO_GRAMS_OUT_OF_STOCK, DROPSHIP_ORDER_STATUS, EXPRESS_SHIPPING, FREE_PRODUCT_DISPLAY_NAMES, HEALTH_REPORTS, HTTP_METHODS, INELIGIBLE_ORDER_STATUS_TO_UPDATE, IN_TRANSIT_TRACKING_STATUSES, NO_RESUBSCRIBE_CHURN_REASONS, LOT_TRACKED_PRODUCT_TYPES, MIN_MAX_WEIGHTS, ORDER_CHARGE_STATUS, ORDER_FULFILLMENT_ITEM_EXCEPTION_REASONS, ORDER_SOURCE, ORDER_STATUS, PAYMENT_METHOD_ICONS, PET_FEATURES, PET_GENDERS, PET_TYPE, PET_SURVEYS, PHOTO_BASE_URL, PURCHASING_MOTIVATIONS, PRODUCT_TYPES, RECIPE_MODE, RECIPES_TO_DISPLAY_NAMES, RECIPES_TO_PRICE_INDICATORS, REFUND_DESTINATIONS, OPS_INSERTS_AND_PROMOTIONAL_PRODUCT_TYPES, SKIP_TRANSITION_FOODS, SUBSCRIPTION_TYPES, TERMINAL_DROPSHIP_ORDER_STATUSES, TREATS_PRODUCT_TYPES, TRIAL_TYPES, V10_ONLY_RECIPES, VARIETY_PACK_PRODUCT_TYPES, WEEK_OF_MEALS_MAP, };
